import { Navigate, useLocation } from "react-router-dom";
import { useAuth, routeForUser } from "@/context/AuthContext";

/**
 * Wraps a route. Behaviour:
 *  - while loading → null (parent shows nothing; avoids flicker)
 *  - no user → redirect to /login
 *  - user.status !== "approved" → /pending-approval (or /rejected)
 *  - if `roles` prop given and user.role not in it → redirect to user's home
 */
export default function ProtectedRoute({ roles, children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (user.status === "rejected") {
    return <Navigate to="/rejected" replace />;
  }
  if (user.status !== "approved") {
    return <Navigate to="/pending-approval" replace />;
  }
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={routeForUser(user)} replace />;
  }
  return children;
}
